module.exports = __webpack_public_path__ + "img/深圳市第二人民医院.d5b27d41.png";